export default "__VITE_ASSET__AkisAGuI__"